export default __webpack_public_path__ + "static/dashkit-d9bab54d1d0af5bf074b7d9640394eab.jpg";